import Process from "./process/index.js";
import Production from "./production/index.js";
import QualityControl from "./quality_control/index.js";
import QualityReports from "./quality_reports/index.js";

export default [
    ...Process,
    ...Production,
    ...QualityControl,
    ...QualityReports
]
